//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import { useSelector } from 'react-redux';

import { isInsightsPageVisible } from '@insights/redux/selectors/getAvailableInsightsPages';
import { NavMenuItem } from '@legacy-components/nav3/navigation-menus/NavMenuItem';
import { NAV_MENU_ITEMS_TRACKING_ID } from '@legacy-components/nav3/navigation-menus/constants/NavMenuItemConstants';

import { NavGroup } from 'app/initialization/routing/stateHelpers';

export const InsightsNav = () => {
  const isInsightsVisible = useSelector(isInsightsPageVisible);

  if (!isInsightsVisible) {
    return null;
  }

  return (
    <NavMenuItem
      activeNavGroup={NavGroup.INSIGHTS}
      state='insights.summary'
      trackingId={NAV_MENU_ITEMS_TRACKING_ID.INSIGHTS_NAV}
    >
      Insights
    </NavMenuItem>
  );
};
